import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

function Bookings() {
  const [bookings, setBookings] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [priceInput, setPriceInput] = useState("");
  // 🔥 Fetch LiveBookings + Vehicles + Users
  useEffect(() => {
    const q = query(
      collection(db, "LiveBookings"),
      orderBy("pickupTime", "asc"),
    );

    const unsub = onSnapshot(q, async (snapshot) => {
      const bookingsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const customerIds = [
        ...new Set(bookingsData.map((b) => b.customer_id).filter(Boolean)),
      ];

      // ✅ Fetch vehicles (NO condition block)
      const { data: vehicleData } = await supabase.from("Vehicles").select("*");

      setVehicles(vehicleData || []);

      // ✅ Fetch Users from Firestore
      let usersMap = {};
      if (customerIds.length > 0) {
        const usersSnapshot = await getDocs(collection(db, "Users"));

        usersSnapshot.forEach((doc) => {
          if (customerIds.includes(doc.id)) {
            usersMap[doc.id] = doc.data();
          }
        });
      }

      // Merge customer data
      const updatedBookings = bookingsData.map((b) => ({
        ...b,
        customer: usersMap[b.customer_id] || null,
      }));

      setBookings(updatedBookings);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  // Merge vehicle safely (no null error)
  const mergedBookings = bookings.map((booking) => ({
    ...booking,
    vehicle: vehicles.find((v) => v.id == booking.vehicle_id) || null,
  }));

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "N/A";
    return new Date(timestamp.seconds * 1000).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const handleConfirmPrice = async () => {
    if (!priceInput) return toast.error("Enter price");

    try {
      const bookingRef = doc(db, "LiveBookings", selectedBooking.id);

      await updateDoc(bookingRef, {
        confirm_price: 0,
        total_price: Number(priceInput),
      });

      toast.success("Price confirmed successfully");
      setShowModal(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update");
    }
  };

  return (
    <>
      <div className="container" style={{ padding: "20px", marginTop: "35px" }}>
        <h5 className="heading-title mt-4">Live Bookings</h5>

        <div className="row">
          {mergedBookings &&
            mergedBookings.map((v) => (
              <div className="col-md-4">
                <div className="card border-1 shadow-sm mb-3 p-0 rounded-3 overflow-hidden">
                  {/* STATUS STRIP */}
                  <div
                    style={{
                      height: "4px",
                      backgroundColor:
                        v.status == 0
                          ? "#262626"
                          : v.status == 3
                            ? "#0d6efd"
                            : v.status == 4
                              ? "#198754"
                              : v.status == 5
                                ? "#dc3545"
                                : "#adb5bd",
                    }}
                  />

                  <div className="p-3">
                    {/* TOP SECTION */}

                    <div className="uber-locations mb-1">
                      <div className="location-row">
                        <div className="dot pickup-dot"></div>
                        <div className="location-text">
                          <span className="label">Pickup</span>
                          <span className="value">{v.pickup}</span>
                        </div>
                      </div>

                      <div className="short-vertical-line"></div>

                      <div className="location-row">
                        <div className="square drop-square"></div>
                        <div className="location-text">
                          <span className="label">Drop</span>
                          <span className="value">{v.drop}</span>
                        </div>
                      </div>
                    </div>

                    <small
                      className="text-muted mt-1 mb-0"
                      style={{ fontSize: "12.5px" }}
                    >
                      <span style={{ fontWeight: "400" }}>Pick Up:</span>{" "}
                      <b style={{ color: "red" }}>
                        {formatTimestamp(v.pickupTime)}
                      </b>{" "}
                      | {v.booking_type}
                    </small>

                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "5px",
                      }}
                      className={`p-2 ps-3 pe-3 badge ${
                        v.isScheduled ? "bg-danger" : "bg-dark"
                      }`}
                    >
                      {v.isScheduled ? "Scheduled" : "Instant"}
                    </div>

                    <hr className="mb-2 mt-1" />

                    {/* MIDDLE SECTION */}
                    <div className="row align-items-center">
                      {/* VEHICLE */}
                      {v.confirm_price == 1 ? (
                        <>
                          <div className="text-center text-success">
                            <h4 className="mb-2" style={{ fontWeight: "900" }}>
                              {v.total_price}
                            </h4>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-flex align-items-center gap-2 mb-2">
                            {v.vehicle?.img_url ? (
                              <img
                                src={
                                  v.vehicle?.img_url || "/car-placeholder.png"
                                }
                                width={80}
                                className="rounded mb-0"
                              />
                            ) : null}
                            <div>
                              <div className="fw-semibold">
                                {v.vehicle?.name || "Vehicle Not Assigned"}
                              </div>
                              <small className="text-muted">
                                {v.veh_number || "N/A"}
                              </small>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <hr className="mb-2 mt-0" />

                    {/* ACTIONS */}
                    <div className="d-flex justify-content-end gap-2 align-items-center">
                      {/* {v.status < 1 ? (
                        <>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                              setSelectedBooking(v);
                              setPriceInput(v.total_price || "");
                              setShowModal(true);
                            }}
                          >
                            {v.confirm_price == 1
                              ? "Confirm Price"
                              : "Edit Price"}
                          </button>
                        </>
                      ) : null} */}

                      <Link
                        to={`/admin-live-booking-details/${v.id}`}
                        className="btn btn-outline-dark btn-sm"
                      >
                        View Details
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {mergedBookings.length == 0 ? (
          <p className="text-center text-gray mt-5 text-secondary">
            No Bookings
          </p>
        ) : null}
      </div>

      {showModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <h5 className="mb-3">Confirm Price</h5>

            <input
              type="number"
              className="form-control mb-3"
              placeholder="Enter total price"
              value={priceInput}
              onChange={(e) => setPriceInput(e.target.value)}
            />

            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-success btn-sm"
                onClick={handleConfirmPrice}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Bookings;
